var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-cascader", {
        ref: "cascader",
        style: _vm.styles,
        attrs: {
          size: _vm.size,
          placeholder: _vm.placeholder,
          options: _vm.options,
          clearable: "",
          props: {
            checkStrictly: _vm.checkedNode,
            label: "name",
            value: "adcode",
            emitPath: _vm.emitPath,
            multiple: _vm.multiple,
            expandTrigger: _vm.expandTrigger,
          },
          filterable: "",
        },
        on: { change: _vm.handlerChange },
        model: {
          value: _vm.val,
          callback: function ($$v) {
            _vm.val = $$v
          },
          expression: "val",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }